import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { showProductDetialsAction } from "../redux/actions/productsActions";
// import * as LocalStorage from "../../utils/localStorage";
import { FaTimes } from "react-icons/fa";
import styles from "./productsStyles.module.css";
import uploadImg from "../../utils/upload.webp";
const ProductDetailsComponent = () => {
  const actionDispatch = useDispatch();
  const {data:productsData,showProductDetailsComponent,showProduct} = useSelector(
    (state) => state.products
  );
  const closeProductDetails = () => {
    if (showProductDetailsComponent) {
      actionDispatch(showProductDetialsAction({showDetailsComponent:false,showDetails:{}}));
    }
  };
  const editProductDetails =(event)=>{
    event.preventDefault();
    if (showProductDetailsComponent) {
      actionDispatch(showProductDetialsAction({showDetailsComponent:false,showDetails:{}}));
    }
  }
  return (
    <div className={styles.newProductDiv}>
      <h1 className={styles.newProductHeading}>Edit Product</h1>
      <button className={styles.closeAddProduct} onClick={closeProductDetails}>
        <FaTimes />
      </button>
      <div className={styles.addProduct}>
        <form id={styles.editProductForm} onSubmit={editProductDetails}>
          <label htmlFor={styles.productName}>product Name</label>
          <input id={styles.productName} name="name" type="text" defaultValue={showProduct.name}></input>
          <label htmlFor={styles.productDescription}>Description</label>
          <textarea
            name="productDescription"
            id={styles.productDescription}
            defaultValue={showProduct.description}
          ></textarea>
          <label
            htmlFor={styles.selectCategory}
            className={styles.categoriesForNew}
          >
            Category
          </label>
          <select name="categories" id={styles.selectCategory}>
            <option key={showProduct.category} defaultValue={showProduct.category}>
              {showProduct.category}
            </option>
            {productsData.categories.map((category) => {
              return (
                <option key={category} defaultValue={category}>
                  {category}
                </option>
              );
            })}
          </select>
          <label htmlFor={styles.newExpireDate}>Expire Date</label>
          <input
            id={styles.newExpireDate}
            name="expiryDate"
            type="date"
            defaultValue={showProduct.expireDate}
          ></input>
          <label htmlFor={styles.unitsSold}>Units Sold</label>
          <input id={styles.unitsSold} name="unitsSold" type="text" defaultValue={showProduct.unitSold}></input>
          <label htmlFor={styles.newStock}>Units In Stock</label>
          <input id={styles.newStock} name="stock" type="text" defaultValue={showProduct.stock}></input>
          <button className={styles.updatePrdButton+" "+styles.productPageButtons} type="submit">Update Product</button>
        </form>
        <div className={styles.newProductImgDiv}>
          <img
            className={styles.newProductImg}
            src={uploadImg}
            alt="upload"
          ></img>
          <h2 className={styles.uploadProductImage}>Upload image</h2>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailsComponent;
